const ITEMS_PER_PAGE = 18

export default ITEMS_PER_PAGE
